export default __webpack_public_path__ + "static/media/stromrad-stuttgart_ebike-2021_riesemueller-load-75_coal-grey.cda34827.jpeg";